import { action, observable, runInAction } from 'mobx';
import { ErrorInterface } from 'modules/core/api/globalApi';
import isEqual from 'lodash/isEqual';
import statusController from './controller';
import {
  StatusItemInterface, StatusesRequestInterface,
} from '../api/statuses';

type StatusesCacheType = {
  item: StatusItemInterface[],
  request: StatusesRequestInterface,
}

export interface StatusReferenceStore {
  statuses: StatusItemInterface[],
  statusesRequest: StatusesRequestInterface,

  statusesCache: StatusesCacheType[],
  error: ErrorInterface,
}

export const statusReferenceStore: StatusReferenceStore = observable({
  statuses: [],
  error: null,
  statusesCache: [],
} as StatusReferenceStore);

export const statusReferenceActions = {

  getStatusReferenceList: async (request: StatusesRequestInterface): Promise<void> => {
    statusReferenceActions.clearError();

    runInAction(() => {
      statusReferenceStore.statusesRequest = request;
    });

    const cache:StatusItemInterface[] | undefined = statusReferenceStore.statusesCache
      .find((v) => isEqual(v.request, request))?.item;

    if (cache) {
      runInAction(() => {
        statusReferenceStore.statuses = cache;
      });
      return;
    }

    const response = await statusController.getStatusReferenceList(request);
    statusReferenceActions.handleError(response);
    runInAction(() => {
      statusReferenceStore.statuses = response.data;
      statusReferenceStore.statusesCache.push({ request, item: response.data });
    });
  },

  clearStatuses: async (): Promise<void> => {
    statusReferenceActions.clearError();
    runInAction(() => {
      statusReferenceStore.statuses = [];
    });
  },

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      statusReferenceStore.error = errorData;
      throw errorData;
    }
  }),

  clearError: action(() => {
    statusReferenceStore.error = null;
  }),

};
